import get from 'lodash/get';

export const renderAddress = entity =>
  [
    get(entity, 'address'),
    get(entity, 'city'),
    get(entity, 'FL'),
    `${get(entity, 'state')} ${get(entity, 'zip')}`,
  ]
    .filter(str => !!str)
    .join(', ');



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/helpers/renderAddress.js